import { ELSCommonConfig } from '@els/els-ui-common-react';
import { FeatureFlagNames, RoutePath, USER_ENHANCED_ROLE } from 'constants/app.constant';
import { useRouteAnalytics } from 'hooks/useRouteAnalytics';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { appSelectors } from 'redux/ducks/app';
import { PS_PATHS } from 'reports/ps/constants/ps.constant';
import { isFeatureEnabled } from 'services/feature-flag.service';
import TabMenuProvider from '../components/common/tab-menu/TabMenuProvider';
import useDemoUser from '../hooks/useDemoUser';
var DPRouteGuard = function (_a) {
    var children = _a.children, aaData = _a.aaData;
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var userEnhancedRoles = useSelector(appSelectors.getUserEnhancedRoles);
    var loggedInUser = useSelector(appSelectors.getLoggedInUser);
    var userRole = useSelector(appSelectors.getUserRole);
    var isProgramSolutionsEnabled = useSelector(appSelectors.getIsProgramSolutionsEnabled);
    var isDemoUser = useDemoUser();
    // Track page view using route analytics data
    useRouteAnalytics(aaData);
    var isDeanEnhancedRole = Boolean(userEnhancedRoles === null || userEnhancedRoles === void 0 ? void 0 : userEnhancedRoles.includes(USER_ENHANCED_ROLE.DEAN));
    var isFFDeanDashboardEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.DEAN_DASHBOARD_ENABLED);
    var hasBasicRoleAccess = (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.role) === userRole;
    // Use runtime environment from ELSCommonConfig (set by docker-entrypoint.sh)
    var currentEnvironment = ELSCommonConfig.appProfile;
    var isProductionEnvironment = currentEnvironment === 'prod';
    // In production, dean role is required; in other environments, not required
    var hasRoleAccess = isProductionEnvironment ? isDeanEnhancedRole : true;
    var hasAccess = isFFDeanDashboardEnabled && hasBasicRoleAccess && (isDemoUser || hasRoleAccess);
    var redirectUrl = isProgramSolutionsEnabled ? PS_PATHS.homePage : RoutePath.reportingPortal;
    // Redirect immediately if no access
    if (!hasAccess) {
        return <Redirect to={redirectUrl}/>;
    }
    // Render children wrapped with TabMenuProvider for global tab state management
    return <TabMenuProvider>{children}</TabMenuProvider>;
};
export default DPRouteGuard;
